import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Set a component's settings
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSetComponentSettings = packet => {
  return {
    type: 'REQUEST_SET_COMPONENT_SETTINGS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSetComponentSettingsSuccess = data => ({
  type: 'RECEIVE_SET_COMPONENT_SETTINGS_SUCCESS',
  data
})

export const receiveSetComponentSettingsFail = data => ({
  type: 'RECEIVE_SET_COMPONENT_SETTINGS_FAIL',
  data
})

export const tryToSetComponentSettings = packet => (dispatch, getState) => {

  dispatch(requestSetComponentSettings(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  

  let fs = Cookies.get(process.env.REACT_APP_COOKIE_FEATURE_SWITCH)
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/settings/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSetComponentSettingsSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveSetComponentSettingsFail({errors:e, lastSubmit: packet}));
    })
}
